import script from "./hospitalEditForm.vue?vue&type=script&setup=true&lang=js"
export * from "./hospitalEditForm.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__